import type { IconNode } from '../types';

/**
 * @name briefcase-plus
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCA3VjVhMiAyIDAgMCAxIDItMmg0YTIgMiAwIDAgMSAyIDJ2MiIgLz4KICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMTQiIHg9IjIiIHk9IjciIHJ4PSIyIiAvPgogIDxwYXRoIGQ9Ik0xNSAxNEg5IiAvPgogIDxwYXRoIGQ9Ik0xMiAxMXY2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/briefcase-plus
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const briefcasePlus: IconNode = [
  ['path', { d: 'M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2', key: 'gxrri' }],
  ['rect', { width: '20', height: '14', x: '2', y: '7', rx: '2', key: 'mjk0h' }],
  ['path', { d: 'M15 14H9', key: 'u4f7rb' }],
  ['path', { d: 'M12 11v6', key: '1bwqyc' }],
];

export default briefcasePlus;
